import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { compare, filterInstances, sortArray } from '@nu-art/ts-common';
import { ComponentSync } from '../../core/ComponentSync.js';
import { Grid } from '../../components/Layouts/index.js';
import './Component_CollectionGrid.scss';
import { _className } from '../../utils/tools.js';
export class Component_CollectionGrid extends ComponentSync {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.modules = nextProps.modules;
        state.cacheCountMap ??= {};
        state.idbCountMap ??= {};
        return state;
    }
    componentDidMount() {
        this.refreshCountMaps();
    }
    componentDidUpdate(prevProps, prevState) {
        const prevModuleKeys = prevState.modules.map(module => module.dbDef.dbKey);
        const currentModuleKeys = this.state.modules.map(module => module.dbDef.dbKey);
        if (!compare(prevModuleKeys, currentModuleKeys))
            this.refreshCountMaps();
    }
    // ######################## Logic ########################
    refreshCountMaps = async () => {
        const idbCountMap = {};
        const cacheCountMap = {};
        for (const module of this.props.modules) {
            idbCountMap[module.dbDef.dbKey] = await module.IDB.count();
            cacheCountMap[module.dbDef.dbKey] = module.cache._array.length;
        }
        this.setState({ idbCountMap, cacheCountMap });
    };
    getSortedDBKeys = () => {
        const keys = filterInstances(this.state.modules.map(module => {
            const dbKey = module.dbDef?.dbKey;
            if (!dbKey) {
                this.logWarning(`Skipping ${module.getName()}, because it has no dbKey`);
                return;
            }
            return dbKey;
        }));
        //Sort alphabetically
        sortArray(keys);
        //Bring mismatch items to the top
        return sortArray(keys, key => {
            const idbCount = this.state.idbCountMap[key];
            const cacheCount = this.state.cacheCountMap[key];
            return idbCount !== cacheCount ? 0 : 1;
        });
    };
    // ######################## Render ########################
    render() {
        const dbKeys = this.getSortedDBKeys();
        return _jsxs(Grid, { className: 'collections-grid', onClick: () => this.refreshCountMaps(), children: [this.renderHeaders(), dbKeys.map(this.renderDataForKey)] });
    }
    renderHeaders = () => {
        return _jsxs(Grid, { className: 'collections-grid__row header', children: [_jsx("div", { className: 'collections-grid__header', children: "DB Key" }), _jsx("div", { className: 'collections-grid__header', children: "IDB Count" }), _jsx("div", { className: 'collections-grid__header', children: "Cache Count" })] });
    };
    renderDataForKey = (dbKey) => {
        const idbCount = this.state.idbCountMap[dbKey];
        const cacheCount = this.state.cacheCountMap[dbKey];
        const className = _className('collections-grid__row', idbCount !== cacheCount && 'count-mismatch');
        return _jsxs(Grid, { className: className, children: [_jsx("div", { className: 'collections-grid__value', children: dbKey }), _jsx("div", { className: 'collections-grid__value', children: idbCount ?? 'N/A' }), _jsx("div", { className: 'collections-grid__value', children: cacheCount ?? 'N/A' })] }, dbKey);
    };
}
//# sourceMappingURL=Component_CollectionGrid.js.map